<template>
  <div class="content extended-forms">
    <div class="row">
      <ArtistSelect
        class="col-md-12"
        @memberChangeEvent="getArtistInfo"
        :is-filter="true"
        :include-unit-artist="true"
        :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
      />
    </div>
    띄워준 태그
    <div class="row">
      <el-table :data="tags1">
        <el-table-column v-for="column in raisedTableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="135" align="right" label="삭제">
          <div slot-scope="props">
            <base-button @click.native="deleteRaisedTag(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="135" align="right" label="링크">
          <div slot-scope="props">
            <base-button @click.native="showTagCollections(props.row.tagName)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    전체 태그 TOP 5
    <div class="row">
      <el-table :data="tags2">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="135" align="right" label="Actions">
          <div slot-scope="props">
            <base-button @click.native="showTagCollections(props.row.tagName)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    하루 동안 인기태그 TOP 5
    <div class="row">
      <el-table :data="tags3">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="135" align="right" label="Actions">
          <div slot-scope="props">
            <base-button @click.native="showTagCollections(props.row.tagName)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { URLUtils } from "@/util/URLUtils";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    ArtistSelect,
  },
  async created() {},
  data() {
    return {
      unitId: null,
      memberId: null,
      tags1: [],
      tags2: [],
      tags3: [],
      tableColumns: [
        {
          prop: "tagName",
          label: "태그",
          minWidth: 150,
        },
        {
          prop: "tagCount",
          label: "태그수",
          minWidth: 150,
        },
      ],
      raisedTableColumns: [
        {
          prop: "tagName",
          label: "태그",
          minWidth: 100,
        },
        {
          prop: "tagCount",
          label: "태그수",
          minWidth: 100,
        },
        {
          prop: "startTime",
          label: "시작시간",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료시간",
          minWidth: 150,
        },
      ],
    };
  },
  watch: {},
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getRaisedTags();
      await this.getTags(1);
      await this.getTags(2);
    },
    async getRaisedTags() {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };

      const params = { unitId: this.unitId, artistId: this.memberId };

      const path = `/collection/collectionHashTagManage?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get(`/collection/raisedTags`, {
          params,
        })
        .then((res) => {
          this.tags1 = res.data.data.data.map((item) => {
            item.startTime = formatDateTime(item.startTime);
            item.endTime = formatDateTime(item.endTime);
            return item;
          });
        });
    },
    async getTags(type) {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };

      const params = { unitId: this.unitId, artistId: this.memberId, type };

      const path = `/collection/collectionHashTagManage?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get(`/collection/tagList`, {
          params,
        })
        .then((res) => {
          if (type === 1) {
            this.tags2 = res.data.data.data;
          } else if (type === 2) {
            this.tags3 = res.data.data.data;
          }
        });
    },
    deleteRaisedTag(id) {
      const params = { id };
      return this.$axios
        .delete(`/collection/raisedTags`, {
          params,
        })
        .then((res) => {
          Toast.success("삭제되었습니다");
          this.getRaisedTags();
        });
    },
    showTagCollections(tag) {
      this.$router.push(`/collection/collections?unitId=${this.unitId}&state=1&gubun=2&searchWord=${tag}&searchType=1&withParams=detail`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
